import { createSelector } from 'reselect';

import { periodsPerClassIdSelector, periodSelector } from '../../../reducers/selectors';
import { requiresRemainder } from '../../periodUtils';

const hasMorePeriodsSelector = createSelector(
  periodsPerClassIdSelector,
  periodSelector,
  (periods, period) => requiresRemainder(periods, period),
);

export default hasMorePeriodsSelector;
